import request from '@api/request'
import qs from 'qs'

// 用户信息
export const listUserDetail = params =>
  request.get('/entPointEnt/listUserDetail', { params })
// 企业排名
export const pointEntRank = params =>
  request.get('/entPointEnt/pointEntRank', { params })

// 积分文案
export const getPointRuleText = params =>
  request.get('/entPointEnt/getPointRuleText', { params })

// 首次签到
export const codeSignFirst = params =>
  request.get('/entPointEnt/codeSignFirst', { params })

// 标签列表
export const getLabelList = params =>
  request.get('/entPointEnt/getLabelList', { params })

// 领取规则
export const receivePointRule = params =>
  request.post('/entPointEnt/receivePointRule', params)
